
import React from 'react';
import { TableHeader, TableRow, TableHead } from '@/components/ui/table';

interface ReportTableHeaderProps {
  showTeacherDisplay: boolean;
  showAdminColumns: boolean;
}

export const ReportTableHeader: React.FC<ReportTableHeaderProps> = ({ 
  showTeacherDisplay, 
  showAdminColumns 
}) => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>วันที่สอน</TableHead>
        <TableHead>เวลาที่สอน</TableHead>
        <TableHead>ชื่อนักเรียน</TableHead>
        {showTeacherDisplay && <TableHead>ครูผู้สอน</TableHead>}
        <TableHead>สถานะ</TableHead>
        {showAdminColumns && <TableHead>สถานะการเรียน</TableHead>}
        {showAdminColumns && <TableHead>หัวข้อที่เรียน</TableHead>}
        {showAdminColumns && <TableHead className="text-center">ส่งตรงเวลา</TableHead>}
        {showAdminColumns && <TableHead className="text-center">หัก ชม.</TableHead>}
        <TableHead>วันที่บันทึก</TableHead>
        <TableHead className="text-right">ดำเนินการ</TableHead>
      </TableRow>
    </TableHeader>
  );
};
